import { getPartnerLoans } from '~/api/loans';
import { useLoansStore } from '~/store/loans';
import type { LoanUserResponse } from '~/types/api';
import type { LoanFiltersType } from '~/types/loans';
import { resultOf } from '~/utils/fp-results';
import notify from '~/utils/useNotification';

export const fetchLoans = async (filters: LoanFiltersType) => {
    const { setLoans, setLoading } = useLoansStore.getState();

    setLoading(true);
    const [ok, res]: [boolean, LoanUserResponse] = await resultOf(
        getPartnerLoans(filters),
    );

    if (ok && res.success) {
        if (res?.data?.data?.data?.loans.length === 0) {
            notify({
                type: 'info',
                title: 'No loans found',
                description: 'No loans found for the selected filters.',
            });
            setLoans([], 0);
            setLoading(false);
            return true;
        }
        notify({
            type: 'success',
            title: 'Loans fetched',
            description:
                res?.data?.data?.message || 'Loans fetched successfully.',
        });
        setLoans(
            res?.data?.data?.data?.loans || [],
            res?.data?.data?.data?.totalCount || 0,
        );
        setLoading(false);
        return true;
    }

    notify({
        type: 'error',
        title: 'Error fetching loans',
        description: res?.message || 'Failed to fetch loans.',
    });
    setLoans([], 0);
    setLoading(false);
    return false;
};
